/**
 * Every field of a patient list row: the columns LoadPatientsByGroup returns with view=list (its LIST_ATTRIBUTES,
 * checked by test/patientListRowFields.test.js) plus the names, invite and ICD codes it joins in. The saved copy keeps
 * only these, so a full record arriving over the socket is never stored on the device.
 */
export const LIST_ROW_FIELDS = [
  'id', 'groupId', 'hospitalId', 'wardId', 'bed', 'status', 'active', 'isDeceased', 'dateOfDeath',
  'requiresValidation', 'requiresICDValidation', 'wasSelfBoarded', 'inviteCompleted', 'createdAt', 'updatedAt',
  'title', 'name', 'surname', 'patientNumber', 'email', 'mobileNumber', 'dob', 'gender', 'idNumber',
  'passportNumber', 'diagnosis', 'diagnosis2', 'diagnosis3', 'diagnosis4', 'diagnosis5', 'admissionDate',
  'medicalDateJoined',
  'Hospital', 'Ward', 'PatientInvites', 'hospitalName', 'wardName', 'inviteId', 'inviteTokenExpires', 'inviteToken',
  'icdCodes',
];

export function listRow(patient: any): any {
  const row: any = {};
  for (const field of LIST_ROW_FIELDS) {
    if (field in patient) row[field] = patient[field];
  }
  return row;
}

/** The saved rows with the changed ones replaced or added, newest first like the server sends them. */
export function mergeChanges(saved: any[], changed: any[]): any[] {
  const byId = new Map(saved.map(patient => [patient.id, patient]));
  for (const patient of changed) byId.set(patient.id, patient);
  return Array.from(byId.values()).sort((a, b) => String(b.createdAt).localeCompare(String(a.createdAt)));
}

/** SHA-256 hex of the sorted ids joined by commas, the same as LoadPatientsByGroup's idsHash. */
export async function hashIds(ids: string[]): Promise<string> {
  const bytes = await crypto.subtle.digest('SHA-256', new TextEncoder().encode([...ids].sort().join(',')));
  return Array.from(new Uint8Array(bytes), b => b.toString(16).padStart(2, '0')).join('');
}
